import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2DocumentDirectoryOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M30 22V7h-9l-3-4H7v4H2v23h19.672L23 28H4l.007-15.016h2.996L7 26h21.729L30 24H9l.003-14.994L28 9v13zM7.003 10.984H4.007V9.006h2.996zM9 7V5h8.26l1.482 2z" /><path d="M11 16h15v2H11zM11 20h15v2H11zM11 12h7v2h-7z" /></svg>
);
